import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedModule} from '../../../../core/modules/shared.module';
import {ConfirmDialogComponent} from './confirm.dialog.component';

const routes = [{path: 'confirmDialog', component: ConfirmDialogComponent}];

@NgModule({
  declarations: [ConfirmDialogComponent],
  imports: [SharedModule, RouterModule.forChild(routes)],
  exports: [ConfirmDialogComponent]
})

export class ConfirmDialogModule {}


// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/dialogs/confirm/confirm.dialog.module.ts